export interface MateriaResponse {
    id: string;
    nome: string;
    codice: string;

    selected?: boolean;
    valutazione?: number;
}